
import { Component } from "vue-property-decorator";

import { objAny } from "@/common/common-interface";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import {
  getDrawcashPage,
  getDrawcashMch,
  getDrawcashCancel
} from "@/api/api-order-service";

import { getOptionList, optionKey } from "@/api/api-dict";
import piSelectTableData from "@/components/select-table-data/select-table-data.vue";
import tableMaxHeight from "@/mixins/table-max-height/table-max-height";
import { mixins } from "vue-class-component";
import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectOper,
    piSelectTableData
  }
})
export default class PiWithdrawForm extends mixins(tableMaxHeight) {
  private test = "light";
  private time: objAny = {
    startTime: "2020-10-10",
    endTime: "2020-10-31"
  };

  private privilegeVoObj: objAny = {};
  private totalAmount: objAny = {
    chargeTotalAmount: 0,
    rechargeTotalAmount: 0
  };
  private formInline: objAny = {
    auditDateStr: "",
    createDateStr: "",
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    oprPkId: "",
    orderNo: ""
  };
  private loading = false;
  private total = 0;
  private orderStatusList: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [];
  private searchShow = true;
  private allTableData: object[] = [
    {
      title: i18n.t("withdrawal.withdrawOrderNumber"),
      key: "orderNo",
      minWidth: 180
    },
    {
      title: "提现周期",
      key: "totalAmount",
      minWidth: 80
    },
    {
      title: "本期充电总金额",
      key: "totalAmount",
      minWidth: 80
    },
    {
      title: "运营商分成(元)",
      key: "totalAmount",
      minWidth: 80
    },
    {
      title: i18n.t("withdrawal.transferFee"),
      key: "serviceCharges",
      // sortable: true,
      minWidth: 100
    },

    {
      title: i18n.t("withdrawal.actualWithdrawalAmount"),
      key: "transferAmount",
      // sortable: true,
      minWidth: 115
    },
    {
      title: i18n.t("withdrawal.createTime"),
      key: "createTime",
      // sortable: true,
      minWidth: 140
    },

    {
      title: i18n.t("withdrawal.withdrawOrderStatus"),
      key: "orderStatusDesc",
      minWidth: 90,
      slot: "orderStatus"
    },
    {
      title: i18n.t("withdrawal.completeTime"),
      key: "completeTime",
      // sortable: true,
      minWidth: 140
    }
    // {
    //   title: i18n.t("operation"),
    //   slot: "action",
    //   width: 280,
    //   align: "center"
    // }
  ];
  private createDateStr: object[] = [];
  private auditDateStr: object[] = [];
  private sum: objAny = {
    umDrawCashAmount: "",
    drawCashAmount: ""
  };
  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public searchClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
    // this.getStatistics();
    // this.getYearTotal();
  }
  private timeFnCreateDate(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      const startTime = this.$common.userDate(val[0], "yyyy-MM-dd");
      const endTime = this.$common.userDate(val[1], "yyyy-MM-dd");
      this.createDateStr = [startTime, endTime];
      this.formInline.createDateStr = startTime + "~" + endTime;
    } else {
      this.formInline.createDateStr = "";
    }
  }
  private timeFnAuditDate(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      const startTime = this.$common.userDate(val[0], "yyyy-MM-dd");
      const endTime = this.$common.userDate(val[1], "yyyy-MM-dd");
      this.auditDateStr = [startTime, endTime];
      this.formInline.auditDateStr = startTime + "~" + endTime;
    } else {
      this.formInline.auditDateStr = "";
    }
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getDrawcashPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = this.$common.forTableList(ret.data);
    }
    this.loading = false;
  }
  async getDrawcashMch(): Promise<void> {
    this.loading = true;
    const ret = await getDrawcashMch({});
    if (ret.status === this.$config.apiStatus) {
      this.sum.umDrawCashAmount = ret.data[0].umDrawCashAmount;
      this.sum.drawCashAmount = ret.data[0].drawCashAmount;
    }
    this.loading = false;
  }

  async getTypeList() {
    const ret = await getOptionList([optionKey.orderStatusList]); //请求字典
    this.orderStatusList = ret[optionKey.orderStatusList]; // 提现单状态
  }
  public operChange(val: number | string) {
    this.formInline.oprPkId = val;
  }
  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  public addCard(): void {
    this["$common"].remove("withdraw-form-item"); // 删除本地
    this["$common"].save(
      "withdraw-form-umDrawCashAmount",
      this.sum.umDrawCashAmount
    ); // 存储本地

    this["$router"].push("/revenue-settlement/withdraw-form/withdraw-form-add");
  }
  public handleSeeFirst(item: objAny) {
    // this["$common"].save("withdraw-form-item", item); // 存在本地
    this["$router"].push(
      "/revenue-settlement/withdraw-form/cash-template?orderNo=" + item.orderNo
    );
  }
  public handelSubmitAgain(item: objAny) {
    this["$common"].save("withdraw-form-item", item); // 存在本地
    this["$router"].push(
      "/revenue-settlement/withdraw-form/withdraw-form-edit"
    );
  }
  public delForm(item: objAny) {
    this.$Modal.confirm({
      title: i18n.t("withdrawal.withdrawWithdrawal") + "",
      content: `<p>${i18n.t("withdrawal.withdrawWithdrawalConfirm")}</p>`,
      onOk: () => {
        this.getDrawcashCancel(item);
      }
    });
  }
  async getDrawcashCancel(item: objAny) {
    const ret = await getDrawcashCancel({ orderNo: item.orderNo });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("withdrawal.withdrawWithdrawalSuccess"));
      this.getTableList();
    }
  }
  mounted() {
    const month = this.$common.thisTimes("yyyy-MM");
    const endTime = this.$common.thisTimes("yyyy-MM-dd");
    const startTime = month + "-01";

    this.createDateStr = [startTime, endTime];
    this.auditDateStr = [startTime, endTime];
    this.formInline.createDateStr = startTime + "~" + endTime;
    this.formInline.auditDateStr = startTime + "~" + endTime;

    // this.getTypeList();

    this.getTableList();
    this.getDrawcashMch();
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
  }
  beforeRouteEnter(to: objAny, from: objAny, next: Function) {
    if (from.path.indexOf(to.path) != -1) {
      // 从子页面回来
      const name = to.path;
      next((that: objAny) => {
        const formInline = that["$common"].get(name);
        that.formInline = Object.assign(that.formInline, formInline);
      });
    } else {
      next();
    }
  }
  beforeRouteLeave(to: objAny, from: objAny, next: Function) {
    const name = from.path;
    this["$common"].save(name, this.formInline);
    next();
  }
}
